export default "__VITE_ASSET__C2u8Y16a__"